import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-taejung-qna",
  data: function() {
    return {
        viewModel: {
          detail: {
            bbs_id: "TJ_QNA",
          },
        }
    };
  },
  mounted: function() {
    try {
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnCreateQna: function(){
      let vm = this;
      if(vm.viewModel.detail.applicant === null || vm.viewModel.applicant === ''){
        alert("이름을 입력해 주세요.");
        return;
      }
      if(vm.viewModel.detail.email === null || vm.viewModel.email === ''){
        alert("이메일을 입력해 주세요.");
        return;
      }
      if(vm.viewModel.detail.phone === null || vm.viewModel.phone === ''){
        alert("전화번호를 입력해 주세요.");
        return;
      }
      
      let fileUploadType = ["doc", "xlsx", "hwp", "txt", "jpg", "gif", "png", "jpeg", "xml", "pdf", "ppt", "pptx", "docx", "xls", "bmp", "zip"];
        let fileBoo = true;
        for (let i = 0; i < document.mainForm.uploadFiles.length; i++) {
          let fileObj = document.mainForm.uploadFiles[i];
          if (fileObj.files.length > 0) {
            let fileName = fileObj.files[0].name;
            let files = fileName.split(".");
            let fileExt = files[files.length - 1];
            
            if (fileUploadType.indexOf(fileExt) == -1) {
              fileBoo = false;
            }
          }
        }
        if (fileBoo == false) {
          alert("업로드 불가능한 파일형식이 있습니다.");
          return;
        }
        document.forms["mainForm"].submit();
        alert("등록되었습니다.");

    }
  }
});



// WEBPACK FOOTER //
// ./src/uz/taejung/taejung-qna-controller.js